import { createContext, useContext, useState } from "react";
import SignUpSuccess from "../SignUpSuccess/SignUpSuccess";
import BookDemo from "../BookDemo/BookDemo";
import Thankyou from "../Thankyou/Thankyou";
import ContactUs from "../ContactUs/ContactUs";
import ThankyouContactUs from "../ThankyouContactUs/ThankyouContactUs";

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
    const [activeDialog, setActiveDialog] = useState(null);
    const [animation, setanimation] = useState("slideRight")

    const openDialog = (dialogKey, props = {}) => {
        setActiveDialog(dialogKey);
    };

    const closeDialog = () => {
        setanimation("slideLeft")
        setTimeout(() => {
            setActiveDialog(null);
            setanimation("slideRight")
        }, 400);
    };

    return <DialogContext.Provider value={{ activeDialog, openDialog, closeDialog, animation }}>
        {children}
        <SignUpSuccess show={activeDialog == 'signupsuccess'} />
        <BookDemo show={activeDialog == 'bookdemo'} />
        <Thankyou show={activeDialog == 'thankyou'} />
        <ThankyouContactUs show={activeDialog == 'thankyoucontactus'} />
        <ContactUs show={activeDialog == 'contactus'} />
    </DialogContext.Provider>

}

export const useDialog = () => useContext(DialogContext);